import ProductListVariantsQuery from 'Query/ProductListVariants.query';
import { updateProductList } from 'Store/ProductList/ProductList.action';
import { QueryDispatcher } from 'Util/Request';
/**
 * Product Variants Dispatcher
 * @class ProductsVariantssDispatcher
 * @extends ProductsVariantsDispatcher
 * @namespace Bodypwa/Store/ProductsVariants/Dispatcher */
export class ProductsVariantsDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('ProductsVariants');
    }

    onSuccess(data, dispatch, options) {
        const { products: { items } } = data;
        const { args: { search, currentPage: page, filter: { categoryIds: id } = {} } } = options;
        const { id: individualId, page: individualPage } = options;
        /**
         * In case there are no items, or item count is
         * smaller then 0 => the product was not found.
         */
        if (!items || items.length <= 0) {
            return;
        }

        const categoryId = id || individualId || search;

        dispatch(updateProductList({ productsList: items, id: categoryId, page: page || individualPage },
            categoryId));
    }

    prepareRequest(options) {
        return ProductListVariantsQuery.getQuery(options);
    }
}

export default new ProductsVariantsDispatcher();
